import React, { useEffect, useCallback } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Page, FilesDropzone, Header, Alert, SelectField } from 'components';
import { enqueueSnackbar } from 'actions';
import { Card, CardContent,	TextField, Grid, Button, colors } from '@mui/material';
import _ from 'underscore';
import useRouter from 'utils/useRouter';

import ModalDialog from '../../../../components/ModalDialog/ModalDialog.js';
import PagerDutyIncidentDialogForm from './PagerDutyIncidentDialogForm';

import { SetFormState, DeleteIncident, ToggleDeleteIncidentDialog } from '../../actions/PagerDutyIncidentsActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const PagerDutyDeleteIncidentDialog = (props) => {
	const classes = useStyles();
	const { onClose, open, incidentId, ...rest } = props;
	const dispatch = useDispatch();
	const title = 'Do you want to delete this incident?';
	const confirmLabel = 'Delete';
	const formState = useSelector((state) => state.pagerDutyIncidentsReducer.formState);

	const _onConfirmClick = () => {
		if (formState.isValid) {
			dispatch(DeleteIncident(incidentId));
			dispatch(ToggleDeleteIncidentDialog(false, 0));
		}
	};

	return (
		<ModalDialog
			onClose={onClose}
			title={title}
			confirmColor="error"
			open={open}
			confirmLabel={confirmLabel}
			onConfirmClicked={_onConfirmClick}
			maxWidth="lg"
		>
			<PagerDutyIncidentDialogForm allDisabled incidentId={incidentId} />
		</ModalDialog>
	);
};

PagerDutyDeleteIncidentDialog.propTypes = {
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
	incidentId: PropTypes.number,
	submitter: PropTypes.string
};

export default PagerDutyDeleteIncidentDialog;
